import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    name: String,
  };

  dismiss() {
    const data = {
      notification: {
        name: this.nameValue,
      },
    };
    fetch('/notifications', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Accept: 'application/json; charset=utf-8',
      },
    });
  }
}
